import packageData from '../package.json';

export const { version } = packageData;
